"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const environments = [{
  name: "Infrastructure",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1706817/img/infrastructure_strategic_planning.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1706817/img/infrastructure_strategic_planning.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1706817/img/infrastructure_strategic_planning.png-wvc-sizes",
  alt: "Strategic infrastructure project planning site overview",
  specs: [{
    label: "Scope",
    value: "Large-scale"
  }, {
    label: "Phases",
    value: "4-6"
  }, {
    label: "Budget",
    value: "Up to $240M"
  }]
}, {
  name: "Urban Development",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1706817/img/urban_planning_documents.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1706817/img/urban_planning_documents.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1706817/img/urban_planning_documents.png-wvc-sizes",
  alt: "Urban development blueprint and site analysis",
  specs: [{
    label: "Scope",
    value: "Mid-scale"
  }, {
    label: "Phases",
    value: "6-8"
  }, {
    label: "Budget",
    value: "Up to $320M"
  }]
}, {
  name: "Public Facilities",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1706817/img/capital_project_visualization.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1706817/img/capital_project_visualization.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1706817/img/capital_project_visualization.png-wvc-sizes",
  alt: "Public facilities design and planning documentation",
  specs: [{
    label: "Scope",
    value: "Complex"
  }, {
    label: "Phases",
    value: "8-12"
  }, {
    label: "Budget",
    value: "Up to $480M"
  }]
}];
export default function Planning() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: gridRef,
    isVisible: gridVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  return;
}